import { Component, Input } from '@angular/core';

@Component({
  selector: 'cf-storybook-shell-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input()
  public name = '';
}
